/**************************************************
 * Nombre:       Detalle_Complementos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Modalidad from "../../Tarjetas/Tarjeta_Modalidad";
import {theme} from "../../../Tema";
import Tarjeta_Check_Texto from "../../Tarjetas/Tarjeta_Check_Texto";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Detalle_Complementos = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 0 : 4}
                        sx={{px: 2}}
                    >
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{minHeight: 140}}
                        >


                            {item && item.adicionales && item.adicionales.map((it, index) => {

                                if (index > 0) {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                                              sx={{justifyContent: 'flex-start', mt: 6}}>
                                            <Tarjeta_Modalidad item={it}/>
                                        </Grid>
                                    )
                                }

                            })}

                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <Typography
                                sx={{fontSize: sCell ? 22 : 26, fontWeight: 700, color: theme.palette.primary.main}}>Contamos
                                con:</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: sCell ? 2 : 0}}
                            spacing={2}
                        >

                            {item && item.contamos && item.contamos.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Check_Texto item={item}/>
                                </Grid>
                            ))}


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Complementos

